import { ref } from 'vue';
import { toast } from 'vue-sonner';

const loadingEnableQueue = ref(false);
const loadingDisableQueue = ref(false);

export function useQueueControls() {
  const enableQueue = async () => {
    loadingEnableQueue.value = true;
    try {
      await axios.post('/api/v1/pbx/queue/enable');
    } catch (e) {
      console.error(e);
      toast.error('Failed to enable the queue.');
    } finally {
      loadingEnableQueue.value = false;
    }
  };

  const disableQueue = async () => {
    loadingDisableQueue.value = true;
    try {
      await axios.post('/api/v1/pbx/queue/disable');
    } catch (e) {
      console.error(e);
      toast.error('Failed to disable the queue.');
    } finally {
      loadingDisableQueue.value = false;
    }
  };

  return {
    enableQueue,
    disableQueue,
    loadingEnableQueue,
    loadingDisableQueue,
  };
}
